var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',_vm._l((_setup.introNotes),function(content,index){return _c('li',{key:index},[_c('span',{domProps:{"innerHTML":_vm._s(_setup.renderMarkdown(content))}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }